import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography } from '@mui/material';
import { sectionBackgrounds, resolveGradient } from '../../../theme';
/**
 * MapEmbed – embedded map by address (Google Maps). Supports label + gradient.
 */
const MapEmbed = ({ label, gradient, address, title, height = '220', paddingTop, paddingBottom, paddingLeft, paddingRight, marginTop, marginBottom, maxWidth, width = '100%', borderRadius = 2, boxShadow, border, borderColor, componentAlignment = 'left', }) => {
    const background = gradient
        ? resolveGradient(gradient, sectionBackgrounds.hero)
        : 'transparent';
    const encodedAddress = address ? encodeURIComponent(address.trim()) : '';
    const mapUrl = encodedAddress ? `https://www.google.com/maps?q=${encodedAddress}&output=embed` : '';
    return (_jsx(Box, { component: "section", sx: {
            background,
            paddingTop: paddingTop || 3,
            paddingBottom: paddingBottom || 3,
            paddingLeft: paddingLeft || 0,
            paddingRight: paddingRight || 0,
            marginTop: marginTop || 0,
            marginBottom: marginBottom || 0,
            textAlign: componentAlignment,
        }, children: _jsxs(Box, { sx: { maxWidth: maxWidth || 900, mx: 'auto', px: 2 }, children: [label && (_jsx(Typography, { variant: "overline", sx: { display: 'block', mb: 2, color: 'text.secondary', letterSpacing: 1 }, children: label })), title && (_jsx(Typography, { sx: { mb: 1, fontWeight: 600 }, children: title })), _jsx(Box, { sx: {
                        width,
                        borderRadius: typeof borderRadius === 'number' ? borderRadius : borderRadius,
                        overflow: 'hidden',
                        boxShadow: boxShadow || '0 4px 12px rgba(0,0,0,0.12)',
                        border,
                        borderColor: borderColor || 'divider',
                    }, children: mapUrl ? (_jsx("iframe", { title: title || address || 'Map', src: mapUrl, width: "100%", height: height, style: { border: 0, display: 'block' }, loading: "lazy", referrerPolicy: "no-referrer-when-downgrade" })) : (_jsx(Box, { sx: { p: 2, textAlign: 'center' }, children: _jsx(Typography, { variant: "body2", color: "text.secondary", children: "Address is missing" }) })) })] }) }));
};
export default MapEmbed;
